import { TextKey } from '@mews-commander/enums';
import { LocalizedCurrencyValue } from '@mews/framework';
import { HighlightCard } from '../../common/HighlightCard';
import { WidgetCardsWrapper } from '../../common/WidgetCardsWrapper';
import { useGuestLedgerTotalsQuery } from '../hooks/useGuestLedgerTotalsQuery';
import { useGuestLedgerSelectedDate } from '../context/GuestLedgerFilterContext';

export const GuestLedgerHighlightCards = () => {
    const { data, isLoading, error } = useGuestLedgerTotalsQuery();
    const { selectedDate } = useGuestLedgerSelectedDate();
    const showChargesAndPaidCards = false;
    return showChargesAndPaidCards ? (
        <WidgetCardsWrapper>
            <HighlightCard
                title={TextKey.OutstandingBalance}
                date={selectedDate}
                loading={isLoading}
                error={error}
                content={
                    <LocalizedCurrencyValue
                        value={{ value: data?.balance?.value ?? 0, currency: data?.balance?.currencyCode }}
                    />
                }
            />
            <HighlightCard
                title={TextKey.ChargePlural}
                date={selectedDate}
                loading={isLoading}
                error={error}
                content={
                    <LocalizedCurrencyValue
                        value={{ value: data?.charges?.value ?? 0, currency: data?.charges?.currencyCode }}
                    />
                }
            />
            <HighlightCard
                title={TextKey.Paid}
                date={selectedDate}
                loading={isLoading}
                error={error}
                content={
                    <LocalizedCurrencyValue
                        value={{ value: data?.paid?.value ?? 0, currency: data?.paid?.currencyCode }}
                    />
                }
            />
        </WidgetCardsWrapper>
    ) : (
        <WidgetCardsWrapper cardMaxWidth="33%">
            <HighlightCard
                title={TextKey.OutstandingBalance}
                date={selectedDate}
                loading={isLoading}
                error={error}
                content={
                    <LocalizedCurrencyValue
                        value={{ value: data?.balance?.value ?? 0, currency: data?.balance?.currencyCode }}
                    />
                }
            />
        </WidgetCardsWrapper>
    );
};
